export class MongoAtlasSourceAccountAttributesInput {
    'apiPublicKey';
    'apiPrivateKey';
    'atlasProjectId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apiPublicKey",
            "baseName": "apiPublicKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "apiPrivateKey",
            "baseName": "apiPrivateKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasProjectId",
            "baseName": "atlasProjectId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasSourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
